@import '../../../globals/main.scss';
pn-swan {
  a {
    text-decoration: none;

    &:hover {
      text-decoration: none;
      span,
      .pn-swan-text {
        text-decoration: underline;
      }
    }
  }

  .pn-swan__wrapper {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
    gap: 0.8rem;

    color: $gray900;

    @media screen and (min-width: $min-width-md) {
      flex-direction: row;
      gap: 2.4rem;
    }
  }

  .pn-swan-icon__wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .pn-swan-icon {
    svg {
      width: 6rem;
    }
  }

  .pn-swan-icon__preamble {
    text-align: center;
    font-size: 1rem;
    font-weight: 500;

    span {
      display: block;
      font-weight: 400;
    }
  }

  .pn-swan-text {
    font-size: 1.2rem;
    max-width: 20rem;
    text-align: center;
    color: $blue700;

    @media screen and (min-width: $min-width-md) {
      text-align: left;
    }
  }
}
